import { User } from '../services/auth';

export const hasPermission = (user: User | null, permission: string): boolean => {
  if (user?.roles?.some((role) => ['owner', 'admin', 'developer'].includes(role))) {
    return true;
  }
  return user?.permissions?.includes(permission) ?? false;
};
